query GoogleGeocode($input: GooglePlaceDetailsInput!) {
  getGooglePlaceDetails(input: $input) {
    formattedAddress
    coordinates {
      lat
      lng
    }
    address {
      street
      houseNumber
      postcode
      city
      country
      countryCode
    }
  }
}
